import { useQueryClient } from '@tanstack/react-query';
import { useScopedTranslation } from 'application/localization/useScopedTranslation';
import { Button, ButtonColor } from 'components/uikit/buttons/Button';
import { CustomModal } from 'components/uikit/modal/CustomModal';
import { Loading } from 'components/uikit/suspense/Loading';
import React, { useState } from 'react';
import { QueryFactory } from 'services/api';
import styles from './DeleteVariableModal.module.scss';
import { showErrorToast } from 'components/uikit/toast/showToast';
import { useVariablesContext } from '../../variablesContext/VariablesContext';

type DeleteVariableModalProps = {
  onClose: (isDeleted: boolean) => void;
  isOpen: boolean;
  id: number;
  revisionId?: number;
};

export const DeleteVariableModal: React.FC<DeleteVariableModalProps> = (
  props,
) => {
  const i18n = useScopedTranslation('Component.DeleteVariableModal');
  const buttonTitle = useScopedTranslation('Button.Title');
  const [loading, setLoading] = useState<boolean>(false);
  const onModalClose = () => {
    props.onClose(false);
  };
  const { refreshVariables } = useVariablesContext();

  return (
    <CustomModal
      isOpen={props.isOpen}
      onClose={onModalClose}
      isBlocking={true}
      title={i18n.t('title')}
    >
      <Loading loading={loading}>
        <p className={styles.message}>{i18n.t('delete_message')}</p>
        <div className={styles.footer}>
          <Button
            className={styles.button}
            color={ButtonColor.Secondary}
            title={buttonTitle.t('cancel')}
            onClick={async () => {
              onModalClose();
            }}
          />
          <Button
            testId="confirm-delete"
            className={styles.button}
            color={ButtonColor.DestroyPrimary}
            type={'submit'}
            title={buttonTitle.t('delete')}
            onClick={async () => {
              try {
                setLoading(true);
                await QueryFactory.VariableClient.delete_(
                  props.id,
                  props.revisionId,
                );
                await refreshVariables();
                props.onClose(true);
              } catch (e) {
                showErrorToast(e);
              } finally {
                setLoading(false);
              }
            }}
          />
        </div>
      </Loading>
    </CustomModal>
  );
};
